<script lang="ts">
  // Das Kreuz zum Schließen oder Entfernen -- überall dasselbe Symbol in
  // derselben Größe (lib/kreuz.ts). Nur das Zeichen: Knopf, Beschriftung
  // und Verhalten bleiben Sache der Aufrufstelle. Wo ein ganzer Knopf
  // gebraucht wird, nimmt man SymbolKnopf icon="x" (gleiche Größe).
  import Icon from "./Icon.svelte";
  import { KREUZ_PX } from "./kreuz";

  let { groesse = KREUZ_PX }: { groesse?: number } = $props();
</script>

<Icon name="x" size={groesse} />
